import cx from 'classnames'
import Styles from './DirectionalChevron.module.scss'
import { ChevronDown2 } from 'blaze-ui/icons'

export const DirectionalChevron = ({ direction = 'down' }: { direction?: 'up' | 'down' }) => (
  <span className={cx(Styles.chevron, Styles[direction])}>
    <ChevronDown2 />
  </span>
)
